var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vessel-view-data"}},[_c('vessel-form',{attrs:{"mode":"view","itemId":_vm.itemId,"lastSearchCondition":_vm.lastSearchCondition}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }